import { observer } from 'mobx-react-lite';

const members = [
    {
        nickname: 'Dobi',
        quote: 'Dobi want to be free... from money...',
        avatar: 'member_dobi.png',
        // age: 34,
        // description:
        //     'A tired office worker dreaming of financial freedom. Regularly invests in U.S. stocks while quietly questioning capitalism.',
    },
    {
        nickname: 'FrankieDad',
        quote: 'Time is my precious.',
        avatar: 'member_frankiedad.png',
        // age: 41,
        // description:
        //     "A devoted dad investing for his family's future. Prioritizes time over money and believes in slow, steady growth through dividends.",
    },
    {
        nickname: 'StayTheCourse',
        quote: 'Just keep buying.',
        avatar: 'member_staythecourse.png',
        // age: 36,
        // description:
        //     'A Boglehead and index fund loyalist. Ignores market noise and simply automates monthly investments without stress.',
    },
    {
        nickname: 'Minimalist',
        quote: 'Own less. Grow quietly.',
        avatar: 'member_minimalist.png',
        // age: 33,
        // description:
        //     'A minimalist who tracks every won and avoids lifestyle inflation. Prefers ETFs and simple living over flashy returns.',
    },
    {
        nickname: 'StillYOLO',
        quote: 'Driving a Porsche... in my imagination.',
        avatar: 'member_stillyolo.png',
        // age: 38,
        // description:
        //     "An impulsive investor who loves high-risk growth stocks and crypto. Lives by the motto 'You Only Live Once'—especially on payday.",
    },
    {
        nickname: 'LaunchBit',
        quote: 'In action. Debating whether to buy Ethereum for dinner.',
        avatar: 'member_launchbit.png',
        // age: 29,
        // description:
        //     'A crypto enthusiast skipping meals for Bitcoin. Keeps up with Web3 trends and believes in DCA like a daily ritual.',
    },
    {
        nickname: 'CashKing',
        quote: 'I just really like having cash.',
        avatar: 'member_cashking.png',
        // age: 39,
        // description:
        //     'A cautious investor who believes cash is opportunity. Loves spreadsheets, hates overexposure, and waits patiently for market dips.',
    },
    {
        nickname: 'NomNom',
        quote: "When I retire, it's food trips every day.",
        avatar: 'member_nomnom.png',
    },
    {
        nickname: 'Bassline',
        quote: 'Stacking grooves, playing for freedom.',
        avatar: 'member_bassline.png',
    },
    {
        nickname: 'BuffettBro',
        quote: 'Buffett is my spiritual mentor.',
        avatar: 'member_buffettbro.png',
        // age: 42,
        // description:
        //     'A calm, long-term investor channeling the Oracle of Omaha. Enjoys quoting Buffett and spreading the gospel of value investing.',
    },
    {
        nickname: 'DoodleMuse',
        quote: 'Saving now, so I can paint later — every single day.',
        avatar: 'member_doodlemuse.png',
    },
    {
        nickname: 'Histopia',
        quote: 'Born to rule... just not this timeline.',
        avatar: 'member_histopia.png',
    },
];

const MemberCard = observer(({ member }: { member: (typeof members)[number] }) => {
    return (
        <div className="card shadow-sm">
            <div className="card-body items-center p-4 text-center">
                <div className="avatar">
                    <div className="w-28 rounded-full">
                        <img
                            loading="lazy"
                            src={`https://static.retirein40s.com/images/blog_members/${member.avatar}`}
                        />
                    </div>
                </div>
                <div className="card-title">{member.nickname}</div>
                <p>{member.quote}</p>
            </div>
        </div>
    );
});

export const BlogMemberList = observer(() => {
    return (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
            {members.map((member) => (
                <MemberCard key={member.nickname} member={member} />
            ))}
        </div>
    );
});
